import { Box } from '@givebutter/primitives/box';
import { Separator } from '@givebutter/primitives/separator';
import { CampaignCoverPhotoDetails } from 'assets/js/pages/campaign-settings/campaign-details/CampaignCoverPhotoDetails';
import { CampaignMainDetails } from 'assets/js/pages/campaign-settings/campaign-details/CampaignMainDetails';
import { CampaignStoryOrDescription } from 'assets/js/pages/campaign-settings/campaign-details/CampaignStoryOrDescription';
import { useCurrentCampaign } from 'customHooks/useCurrentCampaign';

const CampaignDetails = () => {
    const { data: campaign } = useCurrentCampaign();
    const hasCoverPhoto =
        ['fundraise', 'event'].includes(campaign?.type ?? '') || campaign?.type === 'collect';

    return (
        <Box className={'flex flex-col gap-8 p-8'}>
            <CampaignMainDetails />
            {hasCoverPhoto && (
                <>
                    <Separator />
                    <CampaignCoverPhotoDetails />
                </>
            )}
            {campaign?.type !== 'general' && (
                <>
                    <Separator />
                    <CampaignStoryOrDescription />
                </>
            )}
        </Box>
    );
};

export default CampaignDetails;
